import * as styles from './styles';
import FocusableIconButton from '@components/FocusableIconButton';
import { useAgreementContext } from '@context/Agreement';
import { AGREE_ALL_BUTTON } from '../../../focuskey';
import { useEffect } from 'react';
const AgreementAllButtons = () => {
  const {
    checkAndStartTreatment,
    openSpecificAgreementButtons,
    setWholeAgreement,
    focusAgreeAll
  } = useAgreementContext();

  useEffect(() => {
    focusAgreeAll();
  }, [focusAgreeAll]);

  return (
    <div css={styles.buttonContainer}>
      <FocusableIconButton
        iconType="check"
        focusKey={AGREE_ALL_BUTTON}
        onEnterPress={checkAndStartTreatment}
        onFocus={setWholeAgreement}
      >
        모든 약관 동의
      </FocusableIconButton>

      <FocusableIconButton iconType="arrow" onEnterPress={openSpecificAgreementButtons}>
        개별 약관 보기
      </FocusableIconButton>
    </div>
  );
};

export default AgreementAllButtons;
